import { createAction } from "redux-actions";

const storeDvbiReports = createAction("STORE_DVBI_REPORTS");

export const indexDvbiReports = createAction("API_INDEX_DVBI_REPORTS", (page, per_page) => ({
  baseURL: process.env.REACT_APP_SATTV_ENDPOINT,
  url: "/dvbi-reports?page=" + page + "&per_page=" + per_page,
  onSuccessAction: storeDvbiReports
}));
